import type { ConfigTheming, ThemeType, Theming } from "./types";
import { DEFAULT_PRIMARY_FONT, DEFAULT_SECONDARY_FONT, hexToRgba } from "./utils";

export const getTheming = (
	configTheming: ConfigTheming,
	partnerCode: string,
	cdnUrl: string,
	theme?: ThemeType,
): Theming => {
	const partnerImagesUrl = `${cdnUrl}/partner-assets/${partnerCode}`;
	const defaultImagesUrl = `${cdnUrl}/partner-assets/default`;

	const hasNegativeNavbar = !!configTheming.navbarNegativeColor;
	const brandColor = configTheming.brandColor;

	const themeToUse = theme ?? "light";
	const darkTheme = themeToUse === "dark";
	const useDarkMode = darkTheme ? "dark/" : "";

	return {
		brandColor,
		brandColorTransparent: hexToRgba(configTheming.brandColor, 0.08),
		iconColor: configTheming.iconColor || brandColor,
		iconLineColor: configTheming.iconLineColor,
		buttonColor: configTheming.buttonColor || brandColor,
		navbarColor: configTheming.navbarNegativeColor || configTheming.navbarColor,
		navbarButtonColor: hasNegativeNavbar ? "#FFFFFF" : configTheming.brandColor,
		poweredByPandas: configTheming.poweredByPandas,
		navbarPoweredBy: hasNegativeNavbar ? "white" : "black",
		buttonBorderRadius: configTheming.buttonBorderRadius,
		primaryFonts: configTheming.primaryFonts || DEFAULT_PRIMARY_FONT,
		secondaryFonts: configTheming.secondaryFonts || DEFAULT_SECONDARY_FONT,
		assets: {
			navbarBackgroundUrl:
				configTheming.navbarColor === "#F2F2F2" && !hasNegativeNavbar
					? `${defaultImagesUrl}/email-header-light.png`
					: `${partnerImagesUrl}/email-header.png`,
			navbarLogo: hasNegativeNavbar ? `${partnerImagesUrl}/logo-negative.png` : `${partnerImagesUrl}/logo.png`,
			navbarPandasLogo: hasNegativeNavbar
				? `${defaultImagesUrl}/pandas-logo-white.png`
				: `${defaultImagesUrl}/pandas-logo-black.png`,
			logo: `${partnerImagesUrl}/logo.svg`,
			locatorLogo: `${partnerImagesUrl}/brandmark.png`,
			webappHomePage: `${partnerImagesUrl}/${useDarkMode}webapp-homepage.png`,
			digitizerImage: `${partnerImagesUrl}/${useDarkMode}digitizer-test.png`,
			splashScreen: `${partnerImagesUrl}/${useDarkMode}splash-screen.png`,
		},
	};
};
